import {
  ProcessedDynamicFilter,
  ProcessedStaticFilter,
} from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import {
  Box,
  ChevronDownBigIcon,
  Collapsible,
  Text,
} from '@redbubble/design-system';
import styles from './Filters.module.scss';
import { useFiltersContext } from './FiltersContext';
import { OptionType } from './types';

const MenuTrigger = ({
  collapsed,
  toggleCollapsible,
  heading,
  selectedOptions,
}: {
  collapsed: boolean;
  toggleCollapsible: () => void;
  heading: string;
  selectedOptions: OptionType[];
}) => {
  return (
    <Box
      className={styles.triggerContainer}
      onClick={() => toggleCollapsible()}
      type="button"
      aria-expanded={!collapsed}
    >
      <button className={styles.menuButton} type="button">
        <Box display="flex" flexDirection="column">
          <Text type="display5">{heading}</Text>
          {collapsed && (
            <Text type="body2">
              {selectedOptions.map((option) => option.label).join(', ')}
            </Text>
          )}
        </Box>
        <Box className={collapsed ? styles.closed : styles.open}>
          <ChevronDownBigIcon />
        </Box>
      </button>
    </Box>
  );
};

interface FilterExperienceInputContainerProps {
  filter: ProcessedDynamicFilter | ProcessedStaticFilter;
  children: React.ReactElement<OptionType> | React.ReactElement<OptionType>[];
}

export const FilterExperienceInputContainer = ({
  filter,
  children,
}: FilterExperienceInputContainerProps) => {
  const { loading } = useFiltersContext();

  const selectedOptions: OptionType[] = (filter.options as OptionType[]).filter(
    (option) => option.applied
  );

  const { label } = filter;

  return (
    <Box className={styles.collapsibleContainer} data-label={label}>
      <Collapsible
        trigger={(triggerProps) =>
          MenuTrigger({ heading: label, selectedOptions, ...triggerProps })
        }
      >
        <Box
          className={[
            styles.loadingContainer,
            loading ? styles.isLoading : '',
          ].join(' ')}
        >
          {loading && (
            <Box className={styles.loading} data-testid="loading-spinner">
              <div className={styles.spinner} />
            </Box>
          )}
          <Box marginLeft="xl" marginBottom="m" marginTop="xxs">
            {/* TODO: DEP-3814 filter by colour */}
            {children}
          </Box>
        </Box>
      </Collapsible>
    </Box>
  );
};
